import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgPlayingCards2 = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M14.79 1.715A4.75 4.75 0 0 0 9.277 4.25H8A4.75 4.75 0 0 0 3.25 9v8A4.75 4.75 0 0 0 8 21.75h4a4.75 4.75 0 0 0 4.084-2.322 4.75 4.75 0 0 0 3.733-3.444l2.001-7.468a4.75 4.75 0 0 0-3.359-5.818zM12 4.25h-.96a3.25 3.25 0 0 1 3.362-1.086l3.67.983a3.25 3.25 0 0 1 2.297 3.98l-2 7.468a3.24 3.24 0 0 1-1.663 2.054q.044-.319.044-.649V9A4.75 4.75 0 0 0 12 4.25m-4 1.5A3.25 3.25 0 0 0 4.75 9v8A3.25 3.25 0 0 0 8 20.25h4A3.25 3.25 0 0 0 15.25 17V9A3.25 3.25 0 0 0 12 5.75zm3.4 3.867a1.75 1.75 0 0 0-2.8 0L6.85 11.95a1.75 1.75 0 0 0 0 2.1l1.75 2.333c.7.934 2.1.934 2.8 0l1.75-2.333a1.75 1.75 0 0 0 0-2.1zm-1.6.9a.25.25 0 0 1 .4 0l1.75 2.333a.25.25 0 0 1 0 .3l-1.75 2.333a.25.25 0 0 1-.4 0L8.05 13.15a.25.25 0 0 1 0-.3z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgPlayingCards2;
